import { LineChart, Network, ShieldCheck } from 'lucide-react';
import type { FrameworkStep, ValueProp } from '../types/content';

export const frameworkSteps: FrameworkStep[] = [
  { label: 'Market Insight' },
  { label: 'Strategic Choice' },
  { label: 'Capability' },
  { label: 'Execution' },
  { label: 'Business Value' }
];

export const valueProps: ValueProp[] = [
  {
    icon: LineChart,
    title: 'Customer Intelligence, Applied to Financial Models',
    description: 'Translating market and customer data directly into commercial and financial decisions.'
  },
  {
    icon: Network,
    title: 'Ecosystem Leadership',
    description: 'Orchestrating partners, platforms, and technology providers into one coherent strategy.'
  },
  {
    icon: ShieldCheck,
    title: 'Enterprise Risk Management',
    description: 'Embedding risk discipline into strategic choices, long before they reach the board.'
  }
];
